(function () {
    'use strict';

    angular
        .module('ib-booking-name')
        .controller('BookingNameModalController', BookingNameModalController);

    BookingNameModalController.$inject = ['$uibModalInstance', 'localStorageService', 'GetBookingNameService', 'BookingNameModel', 'object','BookingSearchService'];

    function BookingNameModalController($uibModalInstance, localStorageService, GetBookingNameService, BookingNameModel, object,BookingSearchService) {

        var vm = this;
        vm.model = BookingNameModel;
        vm.errorMessage = null;
        vm.bookingName= 'bookingName';
        vm.accept = function () {
            vm.form.$submitted = true;
            if (vm.form.$valid) {
                GetBookingNameService.getBooking(vm.model.name, object.surname, object.flowId).then(function (data) {
                    localStorageService.set('bookingInfo', data);
                    localStorageService.set('flowId', data.checkinId);
                    BookingSearchService.retrieveOrderComplete(data,vm.bookingName);
                    vm.close();
                }, function (error) {
                    vm.errorMessage = error.message;
                });
            }
        }

        /**
         * @function
         * @name close
         * @desc closes the modal
         */
        vm.close = function () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();


